module.exports = __webpack_public_path__ + "img/logo_mediaasuransi.9063b946.png";